import React from 'react'
import './abstract.scss';
const Abstract = () => {
    return (
        <>
            <section className='abstract_main' id='howitswork'>
                <img src='\assets\groupab.png' className='abstract_img' />
                <img src='\assets\pinkshade.png' className='pinkshade' />
                <div className='innner_abstract'>
                    <div className='custom-container'>
                        <h2>
                            <span>We Abstract the Mess.</span>
                            You Own the Experience.
                        </h2>
                        <div className='main_cards'>
                            <div className='cards'>
                                <img src='\assets\downarrow.svg' />
                                <h3>User deposits what they have</h3>
                                <p>No wallet switching, RPCs, or bridging confusion</p>
                            </div>
                            <div className='cards'>
                                <img src='\assets\multiple.svg' />
                                <h3>Aqua handles swap & bridge</h3>
                                <p>Fast, accurate, invisible to the user</p>
                            </div>
                            <div className='cards'>
                                <img src='\assets\hand.svg' />
                                <h3>Your dApp receives the correct asset</h3>
                                <p>Exactly what your smart contracts expect</p>
                            </div>
                            <div className='cards'>
                                <img src='\assets\money.svg' />
                                <h3>User withdraws what they want</h3>
                                <p>Back to BTC, SOL, or USDT on Tron — no problem</p>
                            </div>
                        </div>
                        <img src='\assets\abimg.png' className='imgggab' />
                        <div className='imgsiiize'>
                            <img src='\assets\phoneab.png' className='imgggab1 img-fluid' />
                        </div>
                    </div>


                </div>
            </section>
        </>
    )
}

export default Abstract
